<div class="d-flex flex-column justify-content-center align-items-center m-0 p-0">
    <div class="text-center process-step-title text-montserrat">
        Paso 1
    </div>
    <div class="text-center py-2 text-montserrat">
        Confirmación de Cancelación
    </div>
    <div class="py-1">
        <img src="assets/images/otros/warning.svg">
    </div>
    <div class="text-center py-2 text-montserrat">
        Apruebo la cancelación de mi póliza a partir de este momento y generación de nota de crédito, así como nombrar a
        INTERprotección como mi agente de seguros para todo este proceso.
    </div>
</div>